import * as React from 'react';
import { connect } from 'react-redux';
// import styled from 'styled-components';

// Components
import * as homeInitialState from './initialState';
import { DefaultWrapper } from '../../components/Layout/DefaultWrapper';
import MenuOpener from '../../components/MenuOpener';
import Footer from '../../components/Layout/Footer';

// Screens
import FeatureScreen from './screens/Feature';
import HistoricalScreen from './screens/Historical';
import CounterScreen from './screens/Counter';
import FooterScreen from './screens/Footer';

class Home extends React.PureComponent {
  constructor(props) {
    super(props);

    // need to set the store for home
    // place to set all the required elements
    // but for now it is just stored in the initialState.js file
    this.homeDetails = homeInitialState.default;
  }

  render() {
    if (this.homeDetails.screens) {
      return (
        <DefaultWrapper>
          {/* menu */}
          <MenuOpener className="menu-opener" />
          <FeatureScreen />
          <HistoricalScreen />
          <CounterScreen />
          <FooterScreen />
          <Footer />
        </DefaultWrapper>
      );
    }
    return <div>Loading..</div>;
  }
}

export default connect()(Home);



// WEBPACK FOOTER //
// ./src/pages/Home/index.jsx